import { ThemeConfig } from "antd";

export const goldTheme: ThemeConfig = {
  token: {
    colorPrimary: "#D4A843",
    colorSuccess: "#52c41a",
    colorError: "#ff4d4f",
    colorWarning: "#faad14",
    colorBgBase: "#fcfbf7",
    colorTextBase: "#1f1f1f",
    colorBorderSecondary: "#ead8a5",
    borderRadius: 6,
    fontFamily: "'Inter', 'Roboto', sans-serif",
  },
  components: {
    Button: {
      colorPrimary: "#D4A843",
      colorPrimaryHover: "#c89923",
      colorPrimaryActive: "#b07f14",
    },
    Layout: {
      bodyBg: "#fcfbf7",
      headerBg: "#fffaf0",
      footerBg: "#1b160a",
    },
    Menu: {
      colorItemBgSelected: "#fff8e7",
      colorItemTextSelected: "#8c6a10",
      itemBorderRadius: 6,
    },
    Card: {
      borderRadiusLG: 8,
    },
  },
};
